<!--
 * @Copyright: 12308
 * @Author: xuxinxiang
 * @Date: 2020-04-10 10:00:50
 * @LastEditTime: 2020-04-26 13:48:28
 * @Description: 
 -->

<template>
    <div class="head-page">
        <h1>
            <img :src="img" />
            <span>国美（天津）水技术工程有限公司</span>
            <small style="margin-left: 1em"
                >USF(Tianjin) Water Technologies and Engineering Co.,Ltd.</small
            >
        </h1>
        <span class="logout" @click="handleCommand">退出</span>
    </div>
</template>

<script>
import img from "@/assets/front/logo.png";
import { deleteToken } from "@/api/main/api-user";
import { putHost } from "@/api/main/api-host";
import { backend } from "@/router";
export default {
    name: "PublicHead",
    data() {
        return {
            img,
        };
    },
    methods: {
        handleCommand() {
            // 注销token
            this.$confirm("是否确认退出系统?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                lockScroll: false,
            })
                .then(() => {
                    deleteToken().then((res) => {
                        if (res.code === 0) {
                            this.$store.dispatch("logoutAction");
                            this.$notify.success({
                                title: "成功",
                                message: "成功退出系统",
                                duration: 500,
                                onClose: () => {
                                    this.$router.replace("/login");
                                },
                            });
                        } else {
                            this.$notify.error({
                                title: "失败",
                                message: res.msg,
                            });
                        }
                    });
                })
                .catch(() => {});
        },
    },
};
</script>
<style lang="less" scoped>
.clear:after {
    content: ".";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
    overflow: hidden;
}
* {
    margin: 0;
    padding: 0;
    list-style: none;
}
.head-page {
    width: 100%;
    height: 80px;
    background-color: #eee;
    text-align: left;
    border-bottom: 3px solid #214d98;
    position: relative;
    h1 {
        margin: 0px 0px 0px 5%;
        line-height: 80px;
        font-size: 26px;
        font-weight: normal;
        color: #313131;
        img {
            vertical-align: middle;
            margin: 0px 12px 0px 0px;
        }
    }
    .logout {
        float: right;
        color: #313131;
        font-size: 16px;
        position: absolute;
        top: 26px;
        right: 5vw;
        cursor: pointer;
        em {
            font-style: normal;
            cursor: pointer;
        }
    }
}
@media (max-width: 1024px) {
    .head-page {
        width: 100%;
        height: 60px;
        h1 {
            margin: 0px 0px 0px 5px;
            line-height: 60px;
            font-size: 16px;
            img {
                margin: 0px 8px 0px 0px;
                max-width: 60px;
            }
        }
        .logout {
            font-size: 14px;
            top: 22px;
            right: 5px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/front/components/head1.vue